export default __webpack_public_path__ + "static/media/t21.min.e3943ec2.png";